import React from "react";
import { useEffect, useState } from "react";
import axios from '../../axios/axiosconf';
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import logo from '../../../resources/img/logo-2.png';
import { buildCuestionarioSearch, withCuestionarioToken } from './cuestionarioPacienteHelpers';

function CuestionarioPaciente4() {

    const queryParams = useLocation().search;
    const qsInit = new URLSearchParams(queryParams);
    const [idPaciente] = useState(qsInit.get('id'));
    const [tokenPaciente] = useState(qsInit.get('token'));

    const [nombreAcompanante, setNombreAcompanante] = useState('');
    const [telefonoAcompanante, setTelefonoAcompanante] = useState('');
    const [parentesco, setParentesco] = useState('');
    const [docAcompanante, setDocAcompanante] = useState('');
    const [emailAcompanante, setEmailAcompanante] = useState('');

    const [logoClienteUrl, setLogoClienteUrl] = useState(null);
    const [errorlist, setErrorlist] = useState({});
    const [loading, setLoading] = useState(false);

    const history = useHistory();

    useEffect(() => {
        if (!idPaciente) return;

        const config = {
            params: {
                id: idPaciente,
                token: tokenPaciente || undefined,
            }
        };

        axios.get('/paciente-publico', config)
            .then(response => {
                const row = response.data[0];
                if (!row) return;
                setLogoClienteUrl(row.logo_cliente_url || null);
                setNombreAcompanante(row.nombre_acompanante || '');
                setTelefonoAcompanante(row.telefono_acompanante || '');
                setParentesco(row.parentesco_acompanante || '');
                setDocAcompanante(row.doc_acompanante || '');
                setEmailAcompanante(row.email_acompanante || '');
            })
            .catch(error => {
                console.log(error);
            });
    }, [idPaciente, tokenPaciente]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const config = {
            id: idPaciente,
            nombre_acompanante: (nombreAcompanante || '').trim(),
            telefono_acompanante: (telefonoAcompanante || '').trim(),
            parentesco_acompanante: (parentesco || '').trim(),
            doc_acompanante: (docAcompanante || '').trim(),
            email_acompanante: (emailAcompanante || '').trim(),
        };

        axios.put('/datos-adicionales-publico', withCuestionarioToken(config, tokenPaciente))
            .then(() => {
                setLoading(false);
                history.push({
                    pathname: '/confirmacion-cuestionario',
                    search: buildCuestionarioSearch(idPaciente, tokenPaciente)
                });
            })
            .catch(error => {
                console.log(error.response?.data);
                setLoading(false);
                setErrorlist(error.response?.data?.errors || {});
            });
    };

    return (
        <div className="contenedor-cuestionario">

            <div style={{ textAlign: 'center' }}>
                <img
                    src={logoClienteUrl || logo}
                    alt={logoClienteUrl ? 'Logo clínica' : 'Smile software'}
                    style={{ maxWidth: 220, maxHeight: 88, objectFit: 'contain' }}
                    onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = logo;
                        e.currentTarget.alt = 'Smile software';
                    }}
                />
            </div>

            <div className="row mb-2" style={{ marginTop: '30px' }}>
                <h1 className="m-0" style={{ textAlign: 'center', width: '100%' }}>Información personal</h1>
            </div>

            <div className="indicador-progreso">
                <div className="indicador-punto completado">1</div>
                <div className="indicador-linea completado"></div>
                <div className="indicador-punto completado">2</div>
                <div className="indicador-linea completado"></div>
                <div className="indicador-punto completado">3</div>
                <div className="indicador-linea completado"></div>
                <div className="indicador-punto completado">4</div>
            </div>

            <form id="quickForm" onSubmit={handleSubmit} autoComplete="off">

                <div className="card cuestionario-paciente">
                    <div className="card-header">
                        <h4 className="card-title w-100">
                            <span className="d-block w-100" style={{ textAlign: 'center' }}>
                                <i className="fas fa-user-friends mr-2 text-info"></i>
                                Responsable / Acompañante
                            </span>
                        </h4>
                        <p className="text-muted text-center mb-0 small">Todos los campos son opcionales.</p>
                    </div>
                    <div id="infobasica" className="collapse show">
                        <div className="card-body">

                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="nombreAcompanante">Nombre</label>
                                        <input type="text" className="form-control" id="nombreAcompanante" value={nombreAcompanante} onChange={(e) => setNombreAcompanante(e.target.value)} />
                                        <div className="invalid-feedback visible">{errorlist.nombre_acompanante}</div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="telefonoAcompanante">Teléfono</label>
                                        <input type="text" className="form-control" id="telefonoAcompanante" value={telefonoAcompanante} onChange={(e) => setTelefonoAcompanante(e.target.value)} />
                                        <div className="invalid-feedback visible">{errorlist.telefono_acompanante}</div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="parentesco">Parentesco</label>
                                        <input type="text" className="form-control" id="parentesco" value={parentesco} onChange={(e) => setParentesco(e.target.value)} />
                                        <div className="invalid-feedback visible">{errorlist.parentesco_acompanante}</div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="docAcompanante">Número de documento</label>
                                        <input type="text" className="form-control" id="docAcompanante" value={docAcompanante} onChange={(e) => setDocAcompanante(e.target.value)} />
                                        <div className="invalid-feedback visible">{errorlist.doc_acompanante}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="emailAcompanante">e-mail</label>
                                        <input type="email" className="form-control" id="emailAcompanante" value={emailAcompanante} onChange={(e) => setEmailAcompanante(e.target.value)} />
                                        <div className="invalid-feedback visible">{errorlist.email_acompanante}</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="row">
                    <button type="submit" className="btn btn-primary" style={{ margin: '0 auto', fontSize: '1.4rem' }}>
                        Continuar&nbsp;
                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                    </button>
                </div>
            </form>
        </div>
    );
}
export default CuestionarioPaciente4;
